module.exports = __webpack_public_path__ + "static/media/slices4@2x.e3b4be84.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slices4@2x.png
// module id = 763
// module chunks = 0 1